<template>
  <Container>
      <b-table striped hover :items="table"></b-table>
  </Container>
</template>

<script>
import Container from '@/components/Container'
import service from '@/services/service.js'
import utils from '@/services/utilities.js'
export default {
  name: 'Main',
  components:{
      Container
  },
  created(){
      let profile = service.getobject('me');
      utils.loading();
      service.get('/payment/proxy/'+ profile.id +'/owned_users', resp=>{
          utils.stopLoading();
          this.table = resp;
          console.log('resp:', resp);
          console.log("table:", this.table);
      }, (code, err)=>{
          utils.stopLoading();
          alert(err);
      })
  },
  data () {
    return {
        table:[]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Main.vue